import React, { forwardRef } from 'react';
import { createPortal } from 'react-dom';

import { DROPDOWN_POSITION_BOTTOM } from './DropDown.constants';
import { useDropDownPresenter } from './DropDown.presenter';
import * as S from './DropDown.styles';

export const DropDown = forwardRef(
  (
    { targetRef, children, position = DROPDOWN_POSITION_BOTTOM, gap = 0, width, height, className },
    ref
  ) => {
    const presenter = useDropDownPresenter({
      ref,
      targetRef,
      position,
      gap,
      children,
      width,
      height,
    });

    return createPortal(
      <S.Container
        className={className}
        ref={presenter.dropDownRef}
        coordinates={presenter.coordinates}
        width={presenter.coordinates?.width}
        position={position}
      >
        {children}
      </S.Container>,
      document.body
    );
  }
);

DropDown.displayName = 'DropDown';
